/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { Dropdown1 } from '../../content/dropdown/Dropdown1'
import { getCSS, getCSSVariableValue } from '../../../assets/ts/_utils'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'
import { DropdownFilterSubject } from '../../content/dropdown/DropdownFilterSubject'
import { DropdownFilterDate } from '../../content/dropdown/DropdownFilterDate'
import { LanguageHelp } from '../../../helpers/LanguageHelper'
import { Link } from 'react-router-dom'
import _ from 'lodash'

type Props = {
  id: string
  className: string
  data?: any[]
  texts?: string[]
  firstColor?: string
  secondColor?: string
  thirdColor?: string
  mainLabel?: string
  sideLabel?: string
  functionSubmit?: any
  functionDownload?: any
  isDownloadContinue?: boolean
  options?: string[]
  selectedOption?: string
  selectedDate?: string
  height?: string
  isCompetitorControl?: boolean
  warnings: { url: string, message: string }[]
  isWaringImageMirror?: boolean
}

function getColor(color: string) {
  return "#" + color;
}

export class ChartsWidgetBubbleDto { label = ""; firstCount = 0; secondCount = 0; thirdCount = 0; }
export class ApexChartBubbleDto { label = ""; subject = ""; data = [[0, 0, 0]]; }

const ChartsWidgetBubble: React.FC<Props> = ({
  id = "bubbleChart",
  className,
  data = [{
    label: 'Bubble1',
    subject: 'Bubble1S1',
    data: [[0, 0, 0]]
  }],
  texts = ["Net Profit", "Net Profit"],
  firstColor = "47be7d",
  secondColor = "f1416c",
  thirdColor = "e4e6ef",
  mainLabel = "Your Statistics",
  sideLabel = "",
  functionSubmit,
  functionDownload,
  isDownloadContinue = false,
  options = [],
  selectedOption = LanguageHelp('All'),
  selectedDate = LanguageHelp('Last 30 days'),
  height = "250px",
  isCompetitorControl = false,
  warnings = [],
  isWaringImageMirror = false
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  // const [countChart, updateCountChart] = React.useState(0);
  const [previusData, updatePreviusData] = React.useState([new ChartsWidgetBubbleDto()]);
  const [isChartCreated, updateIsChartCreated] = React.useState(false);
  const [heightInt, updateHeightInt] = React.useState(0);
  const [chartId, updateChartId] = React.useState('id');

  useEffect(() => {
    // if (countChart === data.length)
    //   return

    // updateCountChart(data.length)
    refreshChart()
  })

  const refreshChart = () => {
    if (!chartRef.current) {
      if (data![0].label === "-") {
        updatePreviusData(data)
      }
      return
    }

    if (isChartCreated) {
      if (JSON.stringify(previusData) === JSON.stringify(data)) {
        return
      }
      updatePreviusData(data)
    }

    var element = document.getElementById("apexcharts" + chartId);
    if (typeof (element) != 'undefined' && element != null) {

      const options = getChartOptions(chartId, heightInt, data, texts)

      ApexCharts.exec(chartId, 'updateOptions', options, true, true);
    } else {
      const chartId = "id" + Math.random().toString(16).slice(2)
      updateChartId(chartId)

      const height = parseInt(getCSS(chartRef.current, 'height'))
      updateHeightInt(height)

      const options = getChartOptions(chartId, heightInt, data, texts)

      const chart = new ApexCharts(chartRef.current, options)
      chart.render()

      updateIsChartCreated(true)
    }
  }

  return (
    <div className={`card ${className}`}>
      <div className='card-header pt-5'>
        <h3 className='card-title d-flex flex-column'>
          <span className='card-label fw-bold text-dark'>{mainLabel}</span>

          <span className='text-muted fw-semibold fs-7'>{sideLabel}</span>
        </h3>
        <div className='card-toolbar'>
          <DropdownFilterSubject className='me-2 mb-2' functionSubmit={functionSubmit} options={options} selectedOption={selectedOption} />
          <DropdownFilterDate className='me-2 mb-2' functionSubmit={functionSubmit} selectedDate={selectedDate} />
          <button
            type='button'
            className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary mb-2'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
            onClick={(e) => { functionDownload() }}
            disabled={isDownloadContinue}
          >
            {!isDownloadContinue && (
              <KTSVG
                path='/media/icons/duotune/arrows/arr044.svg'
                className='svg-icon-3'
              />
            )}
            {isDownloadContinue && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>

      {(data![0].label !== "" && data![0].label !== "-") &&
        <div className='card-body'>
          {/* begin::Chart */}
          <div ref={chartRef} id='kt_charts_widget_bubble_chart' style={{ height: height }} />
          {/* end::Chart */}
        </div>
      }
      {(data![0].label !== "" && (data.length === 1 && data![0].label === "-")) && (
        <div className='text-center p-11'>
          {warnings.map((warning, key) => (
            <Link key={key} to={warning.url}>
              <div>
                {warning.message}
                &nbsp;<KTSVG path='/media/icons/duotune/arrows/arr095.svg' className='svg-icon-2' />
              </div>
            </Link>
          ))}
          <div>
            <img
              className='mw-100 mh-200px'
              alt='metronic'
              style={{ transform: isWaringImageMirror ? 'scaleX(-1)' : 'scaleX(1)' }}
              src={toAbsoluteUrl('/media/illustrations/sketchy-1/1.png')}
            />
          </div>
        </div>
      )}
      {data[0].label === "" &&
        <div className='card-header border-0 pt-5'>
          <span className='indicator-progress' style={{ display: 'block' }}>
            {/* Please wait...{' '} */}
            <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
          </span>
          <div className='card-body'>
            {/* begin::Chart */}
            <div style={{ height: height }} />
            {/* end::Chart */}
          </div>
          {/* end::Chart */}
        </div>
      }
    </div>
  )
}

export { ChartsWidgetBubble }

function getChartOptions(id: string = "bubbleChart", height: number, data?: any[], texts = ['Net Profit', 'Revenue'],): any {
  const labelColor = getCSSVariableValue('--kt-gray-500')
  const borderColor = getCSSVariableValue('--kt-gray-200')
  let lowestNegativeCount = 0
  let labelArray = []
  let series: { name: string; data: never[] }[] = []
  if (texts === undefined) {
    texts = ['Net Profit', 'Revenue']
  }
  if (data) {
    // let highestPositiveCount = Math.max(...(data!.map((a) => a.firstCount)));
    let highestNegativeCount = Math.max(...(data!.map((a) => a.secondCount)));
    // highestNegativeCount = highestNegativeCount > highestPositiveCount ? highestNegativeCount: highestPositiveCount;
    lowestNegativeCount = 0 - (Math.ceil((highestNegativeCount / 100)) * 100);

    let groupByData = _.groupBy(data, ({ label }) => label);
    for (let i = 0; i < Object.keys(groupByData).length; i++) {
      let sentimentGroup = groupByData![Object.keys(groupByData)[i]]

      let serie = {
        name: Object.keys(groupByData)[i],
        data: []
      }

      let serieData: any = []
      for (let i = 0; i < sentimentGroup.length; i++) {
        let sentiment = sentimentGroup![i]

        serieData.push([
          0 - sentiment.secondCount,
          sentiment.firstCount,
          sentiment.firstCount + sentiment.secondCount + sentiment.thirdCount,
          sentiment.label + " | " + sentiment.subject,
        ])
      }
      serie.data = serieData

      series.push(serie)
      labelArray.push(Object.keys(groupByData)[i])
    }
  }

  return {
    series: series,
    colors: ['#FF9900', '#3366CC', '#DC3912', '#109618', '#990099', '#0099C6', '#DD4477', '#66AA00', '#B82E2E', '#316395',
      '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#8B0707', '#329262', '#5574A6'],
    chart: {
      id: id,
      fontFamily: 'inherit',
      type: 'bubble',
      height: height,
      toolbar: {
        // show: false,
        tools: {
          download: false,
          selection: true,
          zoom: true,
          zoomin: false,
          zoomout: false,
          pan: false,
          // reset: "<img class='w-20px h-20px' src='" + toAbsoluteUrl('/media/svg/misc/infography.svg') + "' alt=''/>",
          customIcons: []
        },
      },
      zoom: {
        enabled: true,
        type: 'xy',
        autoScaleXaxis: true,
        autoScaleYaxis: true,
        zoomedArea: {
          fill: {
            color: '#90CAF9',
            opacity: 0.4
          },
          stroke: {
            color: '#0D47A1',
            opacity: 0.4,
            width: 1
          }
        }
      },
      events: {
        zoomed: function (chartContext: any, { xaxis, yaxis }: any) {
          if (yaxis != undefined) {
            let isEmpty = true;
            let newSeries = chartContext.w.globals.initialSeries?.map(function (series: any) {
              let newData: any = [];
              series.data.forEach(function (row: any, index: any) {
                if (row[0] >= xaxis.min && row[0] <= xaxis.max && row[1] >= yaxis[0].min && row[1] <= yaxis[0].max) {
                  newData.push(row);
                  isEmpty = false;
                }
              });
              return {
                name: series.name,
                data: newData
              };
            });

            if (isEmpty) {
              ApexCharts.exec(id, 'updateSeries', chartContext.w.globals.initialSeries, true);
            } else {
              ApexCharts.exec(id, 'updateSeries', newSeries, true);
            }
          }
        },
        beforeResetZoom: function (chartContext: any, { xaxis, yaxis }: any) {
          ApexCharts.exec(id, 'updateSeries', series, true);
        }
      }
    },
    // animations: {
    //   enabled: true,
    //   easing: 'easeinout',
    //   speed: 800,
    //   animateGradually: {
    //     enabled: true,
    //     delay: 150
    //   },
    //   dynamicAnimation: {
    //     enabled: true,
    //     speed: 350
    //   }
    // },
    plotOptions: {
      // bar: {
      //   horizontal: false,
      //   columnWidth: '50%',
      //   borderRadius: 5,
      // },
      bubble: {
        zScaling: true,
        minBubbleRadius: 4,
        maxBubbleRadius: undefined,
      }
    },
    // legend: {
    //   show: false,
    // },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      tickAmount: 5,
      type: 'numeric',
      max: 0,
      // min: lowestNegativeCount,
      // categories: labelArray,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
      title: {
        text: LanguageHelp('Negative')
      }
    },
    yaxis: {
      // max: lowestNegativeCount,
      // min: 0,
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
      opposite: true,
      title: {
        text: LanguageHelp('Positive')
      }
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      style: {
        fontSize: "12px",
      },
      custom: function ({ series, seriesIndex, dataPointIndex, w }: any) {
        var name = w.globals.initialSeries[seriesIndex].name;
        var color = w.globals.colors[seriesIndex];
        var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];

        return '<div class="apexcharts-tooltip-title" style="font-family: inherit; font-size: 12px;">' + (data.length == 4 ? data[3] : name) + '</div>' +
          '<div class="apexcharts-tooltip-series-group apexcharts-active" style="order: 1; display: flex;"><span class="apexcharts-tooltip-marker" style="background-color: ' + color + ';"></span>' +
          '<div class="apexcharts-tooltip-text" style="font-family: inherit; font-size: 12px;">' +
          '<div class="apexcharts-tooltip-y-group"><span class="apexcharts-tooltip-text-y-label">Positive: </span><span class="apexcharts-tooltip-text-y-value">' + data[1] + '</span></div>' +
          '<div class="apexcharts-tooltip-goals-group"><span class="apexcharts-tooltip-text-goals-label">Negative: </span><span class="apexcharts-tooltip-text-goals-value">' + data[0] + '</span></div>' +
          '<div class="apexcharts-tooltip-z-group"><span class="apexcharts-tooltip-text-z-label">Total: </span><span class="apexcharts-tooltip-text-z-value"></span>' + data[2] + '</div>' +
          '</div></div>'
      }
    },
    // colors: [getColor(firstColor), getColor(secondColor), getColor(thirdColor)],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    legend: {
      position: "top",
      showForZeroSeries: false,
    },
    responsive: [
      {
        breakpoint: 1000,
        options: {
          plotOptions: {
            bar: {
              horizontal: false
            }
          },
          legend: {
            position: "bottom"
          }
        }
      }
    ]
  }
}
